export const LANDING_HERO_SECTION_ID = 'landing-hero-section';
export const LANDING_NEXT_SECTION_ID = 'landing-next-section';
export const LANDING_HOW_SECTION_ID = 'landing-how-section';
export const LANDING_FREEDOM_SECTION_ID = 'landing-freedom-section';
export const LANDING_FINAL_SECTION_ID = 'landing-final-section';
